import { createAction } from 'store/utils';
import {
  AddNoteFailureAction,
  AddNoteRequestAction,
  AddNoteSuccessAction,
  AwaitingApprovalFailureAction,
  AwaitingApprovalRequestAction,
  AwaitingApprovalSuccessAction,
  CancelReturnAction,
  CancelReturnFailureAction,
  CancelReturnSuccessAction,
  ChangeActivityRoleAction,
  ChangeStatusAfterUpdateAction,
  CheckEntityStatusFailureAction,
  CheckEntityStatusRequestAction,
  CheckEntityStatusSuccessAction,
  ClientApproveFailureAction,
  ClientApproveRequestAction,
  ClientApproveSuccessAction,
  ExceptionsActionFailureAction,
  ExceptionsActionRequestAction,
  ExceptionsActionSuccessAction,
  FetchActivityLogsFailureAction,
  FetchActivityLogsRequestAction,
  FetchActivityLogsSuccessAction,
  FetchDataPageAction,
  FetchDataPageSuccessAction,
  FetchExcelFileFailureAction,
  FetchExcelFileRequestAction,
  FetchExcelFileSuccessAction,
  FetchRunDataFailureAction,
  FetchRunDataRequestAction,
  FetchRunDataSuccessAction,
  FetchTransactionsFiltersAction,
  FetchTransactionAttachmentFailureAction,
  FetchTransactionAttachmentRequestAction,
  FetchTransactionAttachmentSuccessAction,
  FetchMetadataAttachmentsFailureAction,
  FetchMetadataAttachmentsRequestAction,
  FetchMetadataAttachmentsSuccessAction,
  ClearMetadataAttachmentsAction,
  FetchVatLogsFailureAction,
  FetchVatLogsRequestAction,
  FetchVatLogsSuccessAction,
  UpdateVatReturnLogStatusAction,
  FetchViewRunDataRequestAction,
  GenerateReportFailureAction,
  GenerateReportRequestAction,
  GenerateReportSuccessAction,
  InternallyApproveFailureAction,
  InternallyApproveRequestAction,
  InternallyApproveSuccessAction,
  ClearReconciliationRunAction,
  InvalidateReconciliationGenerateLoadAction,
  LoadReconFailureAction,
  LoadReconRequestAction,
  LoadReconSuccessAction,
  LoadReportRequestAction,
  LoadReportTotalsRequestAction,
  LockReturnFailureAction,
  LockReturnRequestAction,
  LockReturnSuccessAction,
  ManualJournalPostFailureAction,
  ManualJournalPostRequestAction,
  ManualJournalPostSuccessAction,
  NotApproveFailureAction,
  NotApproveRequestAction,
  NotApproveSuccessAction,
  ResetVatDataAction,
  SaveReturnAction,
  SaveReturnFailureAction,
  SaveReturnSuccessAction,
  UpdateReportFieldsFailureAction,
  UpdateReportFieldsRequestAction,
  UpdateReportFieldsSuccessAction,
  SendClientApprovalFailureAction,
  SendClientApprovalRequestAction,
  SendClientApprovalSuccessAction,
  SetCurrentPageAction,
  SetTransactionFiltersAction,
  SetUpdateFromPageAction,
  SubmitReturnFailureAction,
  SubmitHmrcReturnFailureAction,
  SubmitHmrcReturnRequestAction,
  SubmitHmrcReturnSuccessAction,
  SubmitReturnRequestAction,
  SubmitReturnSuccessAction,
  UpdateActivityRoleFailureAction,
  UpdateActivityRoleRequestAction,
  UpdateActivityRoleSuccessAction,
  UploadTransactionAttachmentFailureAction,
  UploadTransactionAttachmentRequestAction,
  UploadTransactionAttachmentSuccessAction,
  ExportToCsvRequestAction,
  ExportToExcelRequestAction,
  BoxValue,
  ExportToExcelDoneAction,
  ExportToCSVDoneAction,
  LoadReportSuccessAction,
} from './types';
import {
  ADD_NOTE_FAILURE,
  ADD_NOTE_REQUEST,
  ADD_NOTE_SUCCESS,
  AWAITING_APPROVAL_FAILURE,
  AWAITING_APPROVAL_REQUEST,
  AWAITING_APPROVAL_SUCCESS,
  CANCEL_RETURN_FAILURE,
  CANCEL_RETURN_REQUEST,
  CANCEL_RETURN_SUCCESS,
  CHANGE_ACTIVITY_ROLE,
  CHANGE_STATUS_AFTER_UPDATE,
  CHECK_ENTITY_STATUS_FAILURE,
  CHECK_ENTITY_STATUS_REQUEST,
  CHECK_ENTITY_STATUS_SUCCESS,
  CLIENT_APPROVE_FAILURE,
  CLIENT_APPROVE_REQUEST,
  CLIENT_APPROVE_SUCCESS,
  EXCEPTIONS_ACTION_FAILURE,
  EXCEPTIONS_ACTION_REQUEST,
  EXCEPTIONS_ACTION_SUCCESS,
  FETCH_ACTIVITY_LOGS_FAILURE,
  FETCH_ACTIVITY_LOGS_REQUEST,
  FETCH_ACTIVITY_LOGS_SUCCESS,
  FETCH_DATA_PAGE_REQUEST,
  FETCH_DATA_PAGE_REQUEST_SUCCESS,
  FETCH_EXCEL_FILE_FAILURE,
  FETCH_EXCEL_FILE_REQUEST,
  FETCH_EXCEL_FILE_SUCCESS,
  FETCH_RUN_DATA_FAILURE,
  FETCH_RUN_DATA_REQUEST,
  FETCH_RUN_DATA_SUCCESS,
  FETCH_TRANSACTION_FILTERS,
  FETCH_TRANSACTION_ATTACHMENT_FAILURE,
  FETCH_TRANSACTION_ATTACHMENT_REQUEST,
  FETCH_TRANSACTION_ATTACHMENT_SUCCESS,
  FETCH_METADATA_ATTACHMENTS_FAILURE,
  FETCH_METADATA_ATTACHMENTS_REQUEST,
  FETCH_METADATA_ATTACHMENTS_SUCCESS,
  CLEAR_METADATA_ATTACHMENTS,
  FETCH_VAT_LOGS_FAILURE,
  FETCH_VAT_LOGS_REQUEST,
  FETCH_VAT_LOGS_SUCCESS,
  UPDATE_VAT_RETURN_LOG_STATUS,
  FETCH_VIEW_RUN_DATA_REQUEST,
  GENERATE_REPORT_FAILURE,
  GENERATE_REPORT_REQUEST,
  GENERATE_REPORT_SUCCESS,
  INTERNALLY_APPROVE_FAILURE,
  INTERNALLY_APPROVE_REQUEST,
  INTERNALLY_APPROVE_SUCCESS,
  CLEAR_RECONCILIATION_RUN,
  LOAD_RECON_FAILURE,
  LOAD_RECON_REQUEST,
  RECON_GENERATE_LOAD_INVALIDATED,
  LOAD_RECON_SUCCESS,
  LOAD_REPORT_REQUEST,
  LOAD_REPORT_TOTALS_REQUEST,
  LOCK_RETURN_FAILURE,
  LOCK_RETURN_REQUEST,
  LOCK_RETURN_SUCCESS,
  MANUAL_JOURNAL_POST_FAILURE,
  MANUAL_JOURNAL_POST_REQUEST,
  MANUAL_JOURNAL_POST_SUCCESS,
  NOT_APPROVE_FAILURE,
  NOT_APPROVE_REQUEST,
  NOT_APPROVE_SUCCESS,
  RESET_VAT_DATA,
  SAVE_RETURN_FAILURE,
  SAVE_RETURN_REQUEST,
  SAVE_RETURN_SUCCESS,
  UPDATE_REPORT_FIELDS_FAILURE,
  UPDATE_REPORT_FIELDS_REQUEST,
  UPDATE_REPORT_FIELDS_SUCCESS,
  SEND_CLIENT_APPROVAL_FAILURE,
  SEND_CLIENT_APPROVAL_REQUEST,
  SEND_CLIENT_APPROVAL_SUCCESS,
  SET_CURRENT_JOURNALS_PAGE,
  SET_TRANSACTION_FILTERS,
  SET_UPDATE_FROM_PAGE,
  SUBMIT_RETURN_FAILURE,
  SUBMIT_HMRC_RETURN_FAILURE,
  SUBMIT_HMRC_RETURN_REQUEST,
  SUBMIT_HMRC_RETURN_SUCCESS,
  SUBMIT_RETURN_REQUEST,
  SUBMIT_RETURN_SUCCESS,
  UPLOAD_TRANSACTION_ATTACHMENT_REQUEST,
  UPDATE_ACTIVITY_ROLE_FAILURE,
  UPDATE_ACTIVITY_ROLE_REQUEST,
  UPDATE_ACTIVITY_ROLE_SUCCESS,
  EXPORT_TO_CSV_REQUEST,
  EXPORT_TO_EXCEL_REQUEST,
  EXPORT_TO_EXCEL_DONE,
  EXPORT_TO_CSV_DONE,
  CANCEL_VAT_SAGA,
  LOAD_REPORT_SUCCESS,
  UPDATE_SUMMARIZED_DATA_SIZE,
  TOUCH_REPORT,
  REFRESH_REPORT_REQUEST,
} from './constants';
import {
  ActivityLog,
  ExceptionsWrapper,
  JournalPostData,
  SaveReturnRequestData,
  VatGenerateRequestData,
  VatReportData,
  VatReturnLog,
  VatRunRequestData,
  ViewRunRequestData,
} from './models';
import { VatRunData } from './models/vatRunData';
import {
  ActivityRoleUpdateRequest,
  VatLoadRequestData,
} from './models/requestData';
import { ActivityRoles, DataLogStatus } from 'store/app/enums';
import { EmailDataParametersRequest } from './models/emailDataParametersRequest';
import { User } from 'store/auth/models';
import { TransactionAttachment } from './models/transactionAttachments';
import {
  AccountFilter,
  ExcelFileResponse,
  JournalType,
  MappingCodes,
  TaxRateFilter,
  TaxRatesFilter,
} from './models/vatReportData';
import { SourceType } from 'store/api/enums';
import { AllExceptionsDetails } from './models/exceptionWrapper';
import { HmrcSubmissionRequest } from './models/hmrcSubmissionRequest';
import { UPDATE_SUBMISSION_LOG } from 'store/organisation/constants';

// Fetch Vat Logs
export const fetchVatLogsRequest = (
  connectionId: string,
  mappingId: string[]
): FetchVatLogsRequestAction =>
  createAction(FETCH_VAT_LOGS_REQUEST, { connectionId, mappingId });

export const fetchVatLogsSuccess = (
  vatReturnLogs: VatReturnLog[]
): FetchVatLogsSuccessAction =>
  createAction(FETCH_VAT_LOGS_SUCCESS, {
    vatReturnLogs,
  });

export const fetchVatLogsFailure = (): FetchVatLogsFailureAction =>
  createAction(FETCH_VAT_LOGS_FAILURE);

export const updateVatReturnLogStatus = (
  dataLogId: string,
  mappingId: string,
  status: string
): UpdateVatReturnLogStatusAction =>
  createAction(UPDATE_VAT_RETURN_LOG_STATUS, {
    dataLogId,
    mappingId,
    status,
  });

// Fetch Run Data
export const fetchRunDataRequest = (
  vatRunRequestData: VatRunRequestData,
  groupContext?: { fromGroup?: boolean; groupId?: string },
  navigateToReport: boolean = true,
  reportRoute?: string
): FetchRunDataRequestAction =>
  createAction(FETCH_RUN_DATA_REQUEST, {
    vatRunRequestData,
    groupContext,
    navigateToReport,
    reportRoute,
  });

export const fetchViewRunDataRequest = (
  viewRunRequestData: ViewRunRequestData
): FetchViewRunDataRequestAction =>
  createAction(FETCH_VIEW_RUN_DATA_REQUEST, { viewRunRequestData });

export const fetchRunDataSuccess = (
  vatRunData: VatRunData
): FetchRunDataSuccessAction =>
  createAction(FETCH_RUN_DATA_SUCCESS, {
    vatRunData,
  });

export const fetchRunDataFailure = (): FetchRunDataFailureAction =>
  createAction(FETCH_RUN_DATA_FAILURE);

// Generate Report
export const generateReportRequest = (
  vatGenerateRequestData: VatGenerateRequestData,
  totalTransactions: number,
  reportId: string,
  prefetchTransactionsPageSize?: number,
  prefetchExceptionsPageSize?: number,
  skipJournalPages?: boolean
): GenerateReportRequestAction =>
  createAction(GENERATE_REPORT_REQUEST, {
    vatGenerateRequestData,
    totalTransactions,
    reportId,
    prefetchTransactionsPageSize,
    prefetchExceptionsPageSize,
    skipJournalPages,
  });

export const loadReportRequest = (
  vatLoadRequestData: VatLoadRequestData,
  reportId: string,
  prefetchPageSize?: number,
  prefetchTransactionsPageSize?: number,
  prefetchExceptionsPageSize?: number,
  skipJournalPages?: boolean
): LoadReportRequestAction =>
  createAction(LOAD_REPORT_REQUEST, {
    vatLoadRequestData,
    reportId,
    prefetchPageSize,
    prefetchTransactionsPageSize,
    prefetchExceptionsPageSize,
    skipJournalPages,
  });

export const loadReportTotalsRequest = (
  mappingId: string,
  dataLogId: string
): LoadReportTotalsRequestAction =>
  createAction(LOAD_REPORT_TOTALS_REQUEST, { mappingId, dataLogId });

export const generateReportSuccess = (
  vatReportData: VatReportData,
  lastPage: boolean,
  firstPage: boolean
): GenerateReportSuccessAction =>
  createAction(GENERATE_REPORT_SUCCESS, {
    vatReportData,
    lastPage,
    firstPage,
  });

export const generateReportFailure = (
  noDataFound: boolean = false
): GenerateReportFailureAction =>
  createAction(GENERATE_REPORT_FAILURE, { noDataFound });

// LoadReconciliation
export const loadReconRequest = (
  tokenId: string,
  toDate: string,
  mappingId?: string,
  asAtDate?: string,
  currency?: string,
  options?: { tiedToReconciliationGenerate?: boolean }
): LoadReconRequestAction =>
  createAction(LOAD_RECON_REQUEST, {
    tokenId,
    toDate,
    mappingId,
    asAtDate: asAtDate ?? toDate,
    currency,
    ...options,
  });

export const invalidateReconciliationGenerateLoad =
  (): InvalidateReconciliationGenerateLoadAction =>
    createAction(RECON_GENERATE_LOAD_INVALIDATED);

export const loadReconSuccess = (
  reconMap: Map<string, string>
): LoadReconSuccessAction =>
  createAction(LOAD_RECON_SUCCESS, {
    reconMap,
  });

export const loadReconFailure = (): LoadReconFailureAction =>
  createAction(LOAD_RECON_FAILURE);

export const clearReconciliationRun = (): ClearReconciliationRunAction =>
  createAction(CLEAR_RECONCILIATION_RUN);

// Save Return
export const saveReturnRequest = (
  saveReturnRequestData: SaveReturnRequestData,
  reportId: string
): SaveReturnAction =>
  createAction(SAVE_RETURN_REQUEST, { saveReturnRequestData, reportId });

export const saveReturnSuccess = (
  dataLogId: string,
  users: User[],
  currentUser: User,
  generatedDate: string,
  updateFromProvider: boolean = false
): SaveReturnSuccessAction =>
  createAction(SAVE_RETURN_SUCCESS, {
    dataLogId,
    users,
    currentUser,
    generatedDate,
    updateFromProvider,
  });

export const saveReturnFailure = (): SaveReturnFailureAction =>
  createAction(SAVE_RETURN_FAILURE);

// Update report fields
export const updateReportFieldsRequest = (
  dataLogId: string,
  reference: string,
  returnTax: string
): UpdateReportFieldsRequestAction =>
  createAction(UPDATE_REPORT_FIELDS_REQUEST, {
    dataLogId,
    reference,
    returnTax,
  });

export const updateReportFieldsSuccess = (): UpdateReportFieldsSuccessAction =>
  createAction(UPDATE_REPORT_FIELDS_SUCCESS);

export const updateReportFieldsFailure = (): UpdateReportFieldsFailureAction =>
  createAction(UPDATE_REPORT_FIELDS_FAILURE);

// Cancel Return
export const cancelReturnRequest = (
  dataLogId: string,
  connectionId: string,
  mappingId: string,
  organisationId?: string
): CancelReturnAction =>
  createAction(CANCEL_RETURN_REQUEST, {
    dataLogId,
    connectionId,
    mappingId,
    organisationId,
  });

export const cancelReturnSuccess = (): CancelReturnSuccessAction =>
  createAction(CANCEL_RETURN_SUCCESS);

export const cancelReturnFailure = (): CancelReturnFailureAction =>
  createAction(CANCEL_RETURN_FAILURE);

// Update Activity Role
export const updateActivityRoleRequest = (
  activityRoleUpdateRequest: ActivityRoleUpdateRequest,
  automaticRequest: boolean = false
): UpdateActivityRoleRequestAction =>
  createAction(UPDATE_ACTIVITY_ROLE_REQUEST, {
    activityRoleUpdateRequest,
    automaticRequest,
  });

export const updateActivityRoleSuccess = (): UpdateActivityRoleSuccessAction =>
  createAction(UPDATE_ACTIVITY_ROLE_SUCCESS);

export const updateActivityRoleFailure = (): UpdateActivityRoleFailureAction =>
  createAction(UPDATE_ACTIVITY_ROLE_FAILURE);

// Add Note
export const addNoteRequest = (
  note: string,
  dataLogId: string
): AddNoteRequestAction => createAction(ADD_NOTE_REQUEST, { note, dataLogId });

export const addNoteSuccess = (): AddNoteSuccessAction =>
  createAction(ADD_NOTE_SUCCESS);

export const addNoteFailure = (): AddNoteFailureAction =>
  createAction(ADD_NOTE_FAILURE);

// Fetch Activity Logs
export const fetchActivityLogsRequest = (
  dataLogId: string
): FetchActivityLogsRequestAction =>
  createAction(FETCH_ACTIVITY_LOGS_REQUEST, { dataLogId });

export const fetchActivitySuccess = (
  activityLogs: ActivityLog[]
): FetchActivityLogsSuccessAction =>
  createAction(FETCH_ACTIVITY_LOGS_SUCCESS, { activityLogs });

export const fetchActivityLogsFailure = (): FetchActivityLogsFailureAction =>
  createAction(FETCH_ACTIVITY_LOGS_FAILURE);

//Change Status
export const changeStatusAfterUpdate = (
  status: DataLogStatus
): ChangeStatusAfterUpdateAction =>
  createAction(CHANGE_STATUS_AFTER_UPDATE, { status });

// Awaiting Approval
export const awaitingApprovalRequest = (
  dataLogId: string,
  reportUrl: string,
  mappingId: string
): AwaitingApprovalRequestAction =>
  createAction(AWAITING_APPROVAL_REQUEST, { dataLogId, reportUrl, mappingId });

export const awaitingApprovalSuccess = (): AwaitingApprovalSuccessAction =>
  createAction(AWAITING_APPROVAL_SUCCESS);

export const awaitingApprovalFailure = (): AwaitingApprovalFailureAction =>
  createAction(AWAITING_APPROVAL_FAILURE);

//Change Activity Role
export const changeActivityRole = (
  activityRole: ActivityRoles,
  userId: string
): ChangeActivityRoleAction =>
  createAction(CHANGE_ACTIVITY_ROLE, {
    activityRole,
    userId,
  });

// Internally Approve
export const internallyApproveRequest = (
  dataLogId: string,
  reportUrl: string,
  mappingId: string
): InternallyApproveRequestAction =>
  createAction(INTERNALLY_APPROVE_REQUEST, { dataLogId, reportUrl, mappingId });

export const internallyApproveSuccess = (): InternallyApproveSuccessAction =>
  createAction(INTERNALLY_APPROVE_SUCCESS);

export const internallyApproveFailure = (): InternallyApproveFailureAction =>
  createAction(INTERNALLY_APPROVE_FAILURE);

// Send for client approval
export const sendClientApprovalRequest = (
  dataLogId: string,
  emailData: EmailDataParametersRequest,
  mappingId: string
): SendClientApprovalRequestAction =>
  createAction(SEND_CLIENT_APPROVAL_REQUEST, {
    dataLogId,
    emailData,
    mappingId,
  });

export const sendClientApprovalSuccess = (): SendClientApprovalSuccessAction =>
  createAction(SEND_CLIENT_APPROVAL_SUCCESS);

export const sendClientApprovalFailure = (): SendClientApprovalFailureAction =>
  createAction(SEND_CLIENT_APPROVAL_FAILURE);

// Client approve
export const clientApproveRequest = (
  dataLogId: string,
  reportUrl: string,
  mappingId: string
): ClientApproveRequestAction =>
  createAction(CLIENT_APPROVE_REQUEST, { dataLogId, reportUrl, mappingId });

export const clientApproveSuccess = (): ClientApproveSuccessAction =>
  createAction(CLIENT_APPROVE_SUCCESS);

export const clientApproveFailure = (): ClientApproveFailureAction =>
  createAction(CLIENT_APPROVE_FAILURE);

// Not approve
export const notApproveRequest = (
  dataLogId: string,
  emailData: EmailDataParametersRequest,
  mappingId: string
): NotApproveRequestAction =>
  createAction(NOT_APPROVE_REQUEST, { dataLogId, emailData, mappingId });

export const notApproveSuccess = (): NotApproveSuccessAction =>
  createAction(NOT_APPROVE_SUCCESS);

export const notApproveFailure = (): NotApproveFailureAction =>
  createAction(NOT_APPROVE_FAILURE);

// Submit Return
export const submitReturnRequest = (
  dataLogId: string,
  mappingId: string
): SubmitReturnRequestAction =>
  createAction(SUBMIT_RETURN_REQUEST, { dataLogId, mappingId });

export const submitReturnSuccess = (): SubmitReturnSuccessAction =>
  createAction(SUBMIT_RETURN_SUCCESS);

export const submitReturnFailure = (): SubmitReturnFailureAction =>
  createAction(SUBMIT_RETURN_FAILURE);

// Submit HMRC Return
export const submitHmrcReturnRequest = (
  dataLogId: string,
  mappingId: string,
  hmrcSubmissionRequest: HmrcSubmissionRequest
): SubmitHmrcReturnRequestAction =>
  createAction(SUBMIT_HMRC_RETURN_REQUEST, {
    dataLogId,
    mappingId,
    hmrcSubmissionRequest,
  });

export const submitHmrcReturnSuccess = (): SubmitHmrcReturnSuccessAction =>
  createAction(SUBMIT_HMRC_RETURN_SUCCESS);

export const submitHmrcReturnFailure = (): SubmitHmrcReturnFailureAction =>
  createAction(SUBMIT_HMRC_RETURN_FAILURE);

// Lock Return
export const lockReturnRequest = (
  dataLogId: string,
  mappingId: string
): LockReturnRequestAction =>
  createAction(LOCK_RETURN_REQUEST, { dataLogId, mappingId });

export const lockReturnSuccess = (): LockReturnSuccessAction =>
  createAction(LOCK_RETURN_SUCCESS);

export const lockReturnFailure = (): LockReturnFailureAction =>
  createAction(LOCK_RETURN_FAILURE);

// RESET
export const resetVatData = (): ResetVatDataAction =>
  createAction(RESET_VAT_DATA);

// Check Entity status
export const checkEntityStatusRequest = (
  connectionId: string
): CheckEntityStatusRequestAction =>
  createAction(CHECK_ENTITY_STATUS_REQUEST, { connectionId });

export const checkEntityStatusSuccess = (): CheckEntityStatusSuccessAction =>
  createAction(CHECK_ENTITY_STATUS_SUCCESS);

export const checkEntityStatusFailure = (): CheckEntityStatusFailureAction =>
  createAction(CHECK_ENTITY_STATUS_FAILURE);

// Fetch excel file

export const fetchExcelFileRequest = (
  reportTypeId: string
): FetchExcelFileRequestAction =>
  createAction(FETCH_EXCEL_FILE_REQUEST, { reportTypeId });

export const fetchExcelFileSuccess = (
  data: ExcelFileResponse
): FetchExcelFileSuccessAction =>
  createAction(FETCH_EXCEL_FILE_SUCCESS, {
    data,
  });

export const fetchExcelFileFailure = (): FetchExcelFileFailureAction =>
  createAction(FETCH_EXCEL_FILE_FAILURE);

// Manual Journal Post

export const manualJournalPostRequest = (
  dataLogId: string,
  mappingId: string,
  journalPostData: JournalPostData
): ManualJournalPostRequestAction =>
  createAction(MANUAL_JOURNAL_POST_REQUEST, {
    dataLogId,
    mappingId,
    journalPostData,
  });

export const manualJournalPostSuccess = (): ManualJournalPostSuccessAction =>
  createAction(MANUAL_JOURNAL_POST_SUCCESS);

export const manualJournalPostFailure = (): ManualJournalPostFailureAction =>
  createAction(MANUAL_JOURNAL_POST_FAILURE);

// Exceptions Action

export const exceptionsActionRequest = (
  dataLogId: string,
  mappingId: string,
  exceptionsWrapper: ExceptionsWrapper[],
  reportId: string,
  allExceptionsDetails: AllExceptionsDetails | null,
  oldReportId: string
): ExceptionsActionRequestAction => {
  return createAction(EXCEPTIONS_ACTION_REQUEST, {
    dataLogId,
    mappingId,
    exceptionsWrapper,
    reportId,
    allExceptionsDetails,
    oldReportId,
  });
};

export const exceptionsActionSuccess = (): ExceptionsActionSuccessAction =>
  createAction(EXCEPTIONS_ACTION_SUCCESS);

export const exceptionsActionFailure = (): ExceptionsActionFailureAction =>
  createAction(EXCEPTIONS_ACTION_FAILURE);

// set Update from page
export const setUpdateFromPageRequest = (
  value: boolean
): SetUpdateFromPageAction => createAction(SET_UPDATE_FROM_PAGE, { value });

export const getDataPageRequest = (
  reportId: string,
  page: number,
  pageSize: number,
  transactionType: string,
  groupingType: string,
  filters?: object
): FetchDataPageAction => {
  return createAction(FETCH_DATA_PAGE_REQUEST, {
    reportId,
    page,
    pageSize,
    transactionType,
    groupingType,
    filters,
  });
};

export const setCurrentJournalsPage = (
  journals: any[],
  transactionType: string,
  total: number
): SetCurrentPageAction => {
  return createAction(SET_CURRENT_JOURNALS_PAGE, {
    journals,
    transactionType,
    total,
  });
};

export const getDataPageRequestSuccess = (): FetchDataPageSuccessAction => {
  return createAction(FETCH_DATA_PAGE_REQUEST_SUCCESS);
};

export const getTransactionsFilters = (
  provider: string,
  connectionId: string,
  mappingId: string
): FetchTransactionsFiltersAction => {
  return createAction(FETCH_TRANSACTION_FILTERS, {
    provider,
    connectionId,
    mappingId,
  });
};

export const setTransactionFiltersResponse = (
  provider: string,
  codes: string[] | null,
  accounts: AccountFilter[] | null,
  taxRates: TaxRateFilter[] | null
): SetTransactionFiltersAction => {
  return createAction(SET_TRANSACTION_FILTERS, {
    provider,
    codes,
    accounts,
    taxRates,
  });
};
// Get transaction attachment
export const fetchTransactionAttachmentRequest = (
  tokenId: string,
  transactionId: string,
  transactionUuid: string,
  provider: string,
  sourceType: string,
  receipts?: boolean
): FetchTransactionAttachmentRequestAction =>
  createAction(FETCH_TRANSACTION_ATTACHMENT_REQUEST, {
    tokenId,
    transactionId,
    transactionUuid,
    provider,
    sourceType,
    receipts,
  });

export const fetchTransactionAttachmentSuccess = (
  transactionAttachments: TransactionAttachment[],
  transactionId: string,
  source: 'fetch' | 'upload' = 'fetch'
): FetchTransactionAttachmentSuccessAction =>
  createAction(FETCH_TRANSACTION_ATTACHMENT_SUCCESS, {
    transactionAttachments,
    transactionId,
    source,
  });

export const fetchTransactionAttachmentFailure =
  (): FetchTransactionAttachmentFailureAction =>
    createAction(FETCH_TRANSACTION_ATTACHMENT_FAILURE);

export const fetchMetadataAttachmentsRequest = (
  connectionId: string,
  metadataId: string,
  fileName?: string
): FetchMetadataAttachmentsRequestAction =>
  createAction(FETCH_METADATA_ATTACHMENTS_REQUEST, {
    connectionId,
    metadataId,
    fileName,
  });

export const fetchMetadataAttachmentsSuccess = (
  attachments: TransactionAttachment[],
  metadataId: string,
  fileName?: string
): FetchMetadataAttachmentsSuccessAction =>
  createAction(FETCH_METADATA_ATTACHMENTS_SUCCESS, {
    attachments,
    metadataId,
    fileName,
  });

export const fetchMetadataAttachmentsFailure =
  (): FetchMetadataAttachmentsFailureAction =>
    createAction(FETCH_METADATA_ATTACHMENTS_FAILURE);

export const clearMetadataAttachments = (): ClearMetadataAttachmentsAction =>
  createAction(CLEAR_METADATA_ATTACHMENTS);

// Upload transaction attachment
export const uploadTransactionAttachmentRequest = (
  tokenId: string,
  transactionId: string,
  transactionUuid: string,
  provider: string,
  file: File,
  sourceType: string
): UploadTransactionAttachmentRequestAction =>
  createAction(UPLOAD_TRANSACTION_ATTACHMENT_REQUEST, {
    tokenId,
    transactionId,
    transactionUuid,
    provider,
    file,
    sourceType,
  });

export const exportToCsvRequest = (
  reportId: string,
  transactionType: JournalType,
  groupingType: string
): ExportToCsvRequestAction => {
  return createAction(EXPORT_TO_CSV_REQUEST, {
    reportId,
    transactionType,
    groupingType,
  });
};

export const exportToExcelRequest = (
  reportId: string,
  mappingId: string,
  fileName: string,
  boxValues: BoxValue[]
): ExportToExcelRequestAction => {
  return createAction(EXPORT_TO_EXCEL_REQUEST, {
    reportId,
    mappingId,
    fileName,
    boxValues,
  });
};

export const cancelVatSaga = () => createAction(CANCEL_VAT_SAGA);

export const exportToExcelDone = (): ExportToExcelDoneAction => {
  return createAction(EXPORT_TO_EXCEL_DONE);
};

export const exportToCSVDone = (): ExportToCSVDoneAction => {
  return createAction(EXPORT_TO_CSV_DONE);
};

export const loadReportSuccess = (): LoadReportSuccessAction => {
  return createAction(LOAD_REPORT_SUCCESS);
};

export const updateSummarizedDataSize = (size: number): any => {
  return createAction(UPDATE_SUMMARIZED_DATA_SIZE, { size });
};

export const touchReport = (reportId: string) => {
  return createAction(TOUCH_REPORT, { reportId });
};

export const refreshReportRequest = (
  vatGenerateRequestData: VatGenerateRequestData,
  reportId: string,
  totalTransactions: number,
  prefetchTransactionsPageSize: number,
  prefetchExceptionsPageSize: number,
  transactionsType: string,
  skipJournalPages?: boolean
): any =>
  createAction(REFRESH_REPORT_REQUEST, {
    vatGenerateRequestData,
    reportId,
    totalTransactions,
    prefetchTransactionsPageSize,
    prefetchExceptionsPageSize,
    transactionsType,
    skipJournalPages,
  });
